import React, { Component, Fragment } from "react"
// import AlertContainer from 'react-alert';
import printer from "../../assets/images/printer.png"
import TrimSidebar from "../../components/TrimSidebar"
import html2canvas from "html2canvas"
import {
    DevelopmentServices,
    CustomerServices,
    UtilityService,
    StyleServices,
    SystemServices,
    FileUploadService
} from "../../services"
import FileUpload from "../../components/FileUpload/FileUpload"
import SupplierSection from "../../components/SupplierSection/SupplierMain/SupplierSection"
import PageHeader from "../../components/Page/PageHeader/PageHeader"
import TrimMainSection from "../../components/TrimMainSection/TrimMainSection"
import Audit from "../../components/Common/audit"

import { connect } from "react-redux"
import Button from "../../components/Buttons/Button"
import PrintDevelopmentTrim from "./print"


//loading
import Loading from "../../components/Common/Loading"
import { inherits } from "util"

class Trim extends Component {
    state = {
        action: "",
        _id: "",
        trim: {
            trimNumber: null,
            trimImage: null,
            HSN: null,
            qr: "",
            trimCategory: null,
            description: null,
            color: null,
            quality: null,
            trimRefNumber: null,
            supplierRef: "",
            sizeNumber: null,
            size: null,
            unit: null,
            comments: null,
            refImages: [],
            supplierSection: {
                fullPackageData: [],
                jobWorkData: []
            }
        },
        disabled: false,
        hsnOptions: [], //HSN OPTIONS
        hsnValue: {
            label: "", //HSN LABEL
            value: "" //HSN VALUE
        },

        //OPTIONS
        trimOptions: {},

        //TRIM SIDEBAR
        trimNumber: "",
        qr: "",
        //TRIM MAIN SECTION
        trimMainValues: {},

        //images
        refImages: [],

        trimPrint: {},

        //loading
        isLoading: false,
        printLoading: false,
        scroll: true
    }

    componentDidMount() {
        // capturing action
        let action, _id
        if (this.props.location.state) {
            action = this.props.location.state.action
            _id = this.props.location.state._id
        }
        if (!action && !_id) {
            const urlParams = new URLSearchParams(this.props.location.search)
            action = urlParams.get("action")
            _id = urlParams.get("_id")
            this.props.history.replace('/Trim', {
                action, _id
            })
        }

        this.setState({
            action,
            _id
        })

        //For view purpose
        if (action === "view") {
            this.setState({
                disabled: !this.state.disabled
            })
        }

        if (action != "add") {
            this.setState({
                scroll: false
            })
        }

        if (action === "view" || action === "edit") {
            DevelopmentServices.getSpecificTrim(_id)
                .then(response => {
                    if (response.status === 200) {
                        let trimData = response.text.data

                        let trim = { ...this.state.trim }
                        Object.keys(trimData).forEach(function (key) {
                            if (key in trim) {
                                // or obj1.hasOwnProperty(key)
                                trim[key] = trimData[key]
                            }
                        })

                        this.setState({
                            trim
                        })
                    }
                    if (response.status === 401) {
                        this.props.unauthorisedFunc()
                    }
                })
                .catch(error => {
                    this.props.getalertMessage("error", error.toString())
                })
        }

        var trimOptions = {}
        DevelopmentServices.getTrimDevelopmentOptions()
            .then(res => {
                if (res.status === 200) {
                    // TRIM OPTIONS

                    //TRIM CATEGORY
                    trimOptions.trimCatOptions = res.text.data.trim.TRIMCATEGORY

                    //TRIM STATUS
                    trimOptions.trimStatusOptions = res.text.data.trim.TRIMSTATUS

                    //TRIM TYPES
                    trimOptions.trimTypesOptions = res.text.data.trim.TRIMTYPE

                    //TRIM SIZES

                    trimOptions.trimSizeOptions1 = res.text.data.trim.TRIMSIZE1

                    trimOptions.trimSizeOptions2 = res.text.data.trim.TRIMSIZE2

                    //trim quality

                    trimOptions.trimQualityOptions = res.text.data.trim.TRIMQUALITY

                    //TRIM DESC

                    trimOptions.trimDescOptions = res.text.data.trim.TRIMDESCRIPTION

                    //TRIM COLOR

                    trimOptions.trimColorOptions = res.text.data.trim.TRIMCOLOR

                    //supplier section

                    trimOptions.SUPPLIERNAME = res.text.data.trim.SUPPLIERNAME
                    trimOptions.SHIPMENTTERM = res.text.data.trim.SHIPMENTTERM
                    trimOptions.SHIPMENTMODE = res.text.data.trim.SHIPMENTMODE
                    trimOptions.PORTOFPICKUP = res.text.data.trim.PORTOFPICKUP
                    trimOptions.PURPOSE = res.text.data.trim.PURPOSE
                    trimOptions.PROCESS = res.text.data.trim.PROCESS
                    trimOptions.TRIMUNITS = res.text.data.trim.TRIMUNITS
                    trimOptions.IMAGETYPE = res.text.data.trim.IMAGETYPE
                    trimOptions.GST = res.text.data.trim.GST
                    trimOptions.TRANSPORT = res.text.data.trim.TRANSPORT

                    this.setState({
                        trimOptions
                    })
                }
                res.status === 401 && this.props.unauthorisedFunc()
            })
            .catch(error => this.props.getalertMessage("error", error.toString()))

        //hsn
        let options = []
        DevelopmentServices.getTrimDevelopmentHSN("").then(async data => {
            data.data.map(res => options.push({ label: res.name, value: res._id }))
        })
        this.setState({ hsnOptions: options })

        //supplierName
        SystemServices.listSystemSuppliers()
            .then(response => {
                if (response.status === 200) {
                    let suppliersOption = []
                    response.text.data.data.map(data => {
                        suppliersOption.push({
                            label: data.supplierName,
                            value: data._id
                        })
                    })
                    this.setState({ suppliersOption, isLoading: true })
                }
                if (response.status === 401) {
                    this.props.unauthorisedFunc()
                }
            })
            .catch(error => this.props.getalertMessage("error", error.toString()))

        if (this.state.action === 'add') {
            window.addEventListener("beforeunload", function (event) {
                event.returnValue = "Hellooww"
            })
        }
    }

    componentWillUnmount() {
        if (this.state.action === 'add') {
            window.removeEventListener("beforeunload", function (event) {
                event.returnValue = "Hellooww"
            })
        }
    }


    // handle Customer Search
    handleCustomerInfo = value => {
        CustomerServices.searchCustomersBy("customerId", value)
            .then(({ data = [] } = {}) => {
                var customerInfo = data.map((info, index) => {
                    return {
                        label: info.customerName,
                        value: info._id
                    }
                })
                this.setState({ customerInfo })
            })
            .catch(error => this.props.getalertMessage("error", error.toString()))
    }

    // getting customer ID from drop down
    handleSelect = (data, name) => {
        if (data) {
            this.setState(
                {
                    [name]: data.value
                },
                () => { }
            )
        } else {
            this.setState({
                [name]: ""
            })
        }
    }

    handleInput = ({ target: { value, name } }) => {
        this.setState({
            [name]: value
        })
    }

    //getRefImages
    getRefImages = refImages => {
        let trim = { ...this.state.trim }
        trim.refImages = refImages
        this.setState({
            trim
        })
    }

    changeImg = e => {
        FileUploadService.uploadFile(e.target.files[0], "trim")
            .then(response => {
                if (response.status === 200) {
                    let trim = { ...this.state.trim }
                    trim.trimImage = response.text.data.url
                    this.setState({
                        trim
                    })
                } else if (response.status === 401) {
                    this.props.unauthorisedFunc()
                }
            })
            .catch(error => this.props.getalertMessage("error", error.toString()))
    }

    /*************** */

    //ONCHANGE
    onChange = (name, value) => {
        let trim = { ...this.state.trim }
        trim.HSN = value
        this.setState({ trim })
    }

    getHsnOptions = async e => {
        //GET HSN OPTIONS ONCHANGE
        var options = []
        await DevelopmentServices.getTrimDevelopmentHSN(e).then(async data => {
            await Promise.all(
                data.data.map(res => options.push({ label: res.name, value: res._id }))
            )
        })
        this.setState({ hsnOptions: options })
    }

    //ON SELECT
    onSelect = (name, value) => {
        var trim = { ...this.state.trim }
        trim[name] = value
        if (name == "trimCategory") {
            this.state.trimOptions.trimCatOptions.map(data => {
                if (value === data.value) {
                    trim.trimRefNumber = data.trimRef
                    trim.unit = data.unit
                }
            })

            DevelopmentServices.getTrimDevelopmentQR(trim.trimRefNumber)
                .then(response => {
                    if (response.status === 200) {
                        let trim = { ...this.state.trim }
                            ; (trim.trimNumber = response.text.data.trimNumber),
                                (trim.qr = response.text.data.qr),
                                this.setState({
                                    trim
                                })
                    }
                    if (response.status === 401) {
                        this.props.unauthorisedFunc()
                    }
                })
                .catch(error => {
                    this.props.getalertMessage("error", error.toString())
                })
        }
        this.setState({ trim })
    }

    //Get supplier
    getSupplier = (data, name) => {
        let trim = { ...this.state.trim }
        trim.supplierSection.supplierData =
            name === "fullPackageData" ? "fullPackage" : "jobWork"
        trim.supplierSection[name] = data
        this.setState({
            trim
        })
    }

    //saving Trim
    onSubmit = e => {
        e.preventDefault()

        let trim = { ...this.state.trim }
        if (this.state.action === "edit") {
            trim._id = this.state._id
        }
        let dltEmtF = ['trimCategory', 'description', 'color', 'quality', 'sizeNumber', 'size', 'unit']
        dltEmtF.forEach((x, i) => {
            if (trim[x] === "") {
                trim[x] = null
            }
        })

        DevelopmentServices.createTrimForMarket(trim)
            .then(response => {
                if (response.status === 200) {
                    this.setState({ _id: response.text.data._id })
                    this.props.getalertMessage("success", " Trim Created ")
                }
                if (response.status === 401) {
                    this.props.unauthorisedFunc()
                }
            })
            .catch(error => this.props.getalertMessage("error", error.toString()))
    }

    removeFabricImage = () => {
        let trim = { ...this.state.trim }
        trim.trimImage = ""
        this.setState({
            trim
        })
    }

    //fullpackage

    getFullPackage = fullPackageData => {
        let trim = { ...this.state.trim }
        fullPackageData.map((data, index) => {
            data.purposeLabel =
                data.purpose !== null &&
                this.state.trimOptions && this.state.trimOptions.PURPOSE &&
                this.state.trimOptions.PURPOSE.map((purpose, i) => {
                    if (purpose.value === data.purpose) {
                        return purpose.label;
                    }
                }).filter(Boolean)[0];

            data.SupplierNameLabel =
                data.supplierName !== null &&
                this.state.trimOptions && this.state.trimOptions.SUPPLIERNAME &&
                this.state.trimOptions.SUPPLIERNAME.map((SUPPLIERNAME, i) => {
                    if (SUPPLIERNAME.value === data.supplierName) {
                        return SUPPLIERNAME.label;
                    }
                }).filter(Boolean)[0];
        });
        if (trim) {
            trim.supplierSection.fullPackageData = fullPackageData
            this.setState({
                trim
            })

        } else {
            let fabric = { ...this.state.fabric }
            fabric.supplierSection.fullPackageData = fullPackageData
            this.setState({
                fabric
            })
        }
    }

    getJobwork = jobWorkData => {
        let trim = { ...this.state.trim }
        jobWorkData.map((data, index) => {
            data.purposeLabel =
                data.purpose !== null &&
                this.state.trimOptions.PURPOSE &&
                this.state.trimOptions.PURPOSE.map((purpose, i) => {
                    if (purpose.value === data.purpose) {
                        return purpose.label;
                    }
                }).filter(Boolean)[0];

            data.rowData.map((dat, i) => {
                dat.SupplierNameLabel =
                    dat.supplierName !== null &&
                    this.state.trimOptions.SUPPLIERNAME &&
                    this.state.trimOptions.SUPPLIERNAME.map((SUPPLIERNAME, i) => {
                        if (SUPPLIERNAME.value === dat.supplierName) {
                            return SUPPLIERNAME.label;
                        }
                    }).filter(Boolean)[0];
            });
        });
        trim.supplierSection.jobWorkData = jobWorkData
        this.setState({
            trim
        })
    }

    printTrim = () => {

        let { trim } = { ...this.state }
        let trimPrint = {}
        trimPrint.trimNumber = trim.trimNumber
        trimPrint.trimImage = trim.trimImage
        trimPrint.comments = this.state.trim.comments

        let arr = ['trimCategory', 'color', 'description', 'quality', 'unit', 'sizeNumber', 'size']
        arr.forEach((x) => {
            let res = document.getElementById("fabricCreation").elements.namedItem(x).selectedOptions[0].innerHTML
            trimPrint[x] = res !== 'select' && res || ""
        })
        trimPrint.trimRef = trim.trimRefNumber || ""
        trimPrint.supplierRef = trim.supplierRef || ""
        trimPrint.comments = trim.comments
        trimPrint.refImages = trim.refImages
        let { trim: { supplierSection } } = this.state
        trimPrint.fullPackageData = supplierSection && supplierSection.fullPackageData && [supplierSection.fullPackageData.find(x => x.default)]
        trimPrint.jobWorkData = supplierSection && supplierSection.jobWorkData && [supplierSection.jobWorkData.find(x => x.default)]
        // let { supplierSection } = { ...trim }

        // supplierSection.fullPackageData && supplierSection.fullPackageData.find((x, i) => {
        //     if (x.default) {
        //         fullPackage = `fullPack${i}`
        //         trimPrint.supplier = true
        //         // trimPrint.fullPackage = true
        //         // trimPrint.fullPackageData = x
        //         // let res = document.querySelectorAll(`#fullPack${i} .select-currency`)[0].selectedOptions[0].innerHTML
        //         // x.purpose = res !== 'select' && res || ""
        //         // res = document.querySelectorAll(`#fullPack${i} .select-currency`)[1].selectedOptions[0].innerHTML
        //         // x.supplierName = res !== 'select' && res || ""
        //     }
        // })
        // supplierSection.jobWorkData && supplierSection.jobWorkData.find((x, i) => {
        //     if (x.default) {
        //         jobWork = `jobWrk${i}`
        //         trimPrint.supplier = true
        //         // trimPrint.jobWork = true
        //         // trimPrint.jobWorkData = x
        //     }
        // })

        // if (fullPackage || jobWork) {
        //     this.setState({ trimPrint }, () => {
        //         document.querySelector(`#${fullPackage || jobWork} .card`).style['box-shadow'] = 'none';
        //         var divToPrint = document.querySelector(`#${fullPackage || jobWork} .card`)
        //         var divToPrint1 = document.getElementById('printDevelopmentTrim')
        //         html2canvas(divToPrint).then(canvas => {
        //             const imgData = canvas.toDataURL("image/png")
        //             var img = document.createElement("img")
        //             img.style = {
        //                 width: "98%",
        //                 height: 'auto',
        //                 margin: "0 auto"
        //             }
        //             img.src = imgData
        //             document.getElementById('imgsupplier').innerHTML = img.outerHTML;
        //             setTimeout(() => {
        //                 var newWin = window.open("", "mywindow")
        //                 newWin.document.write(divToPrint1.outerHTML)
        //                 newWin.focus()
        //                 newWin.print()
        //                 // this.onPrintFinished(newWin.print())
        //                 newWin.close()
        //             }, 100);
        //             document.querySelector(`#${fullPackage || jobWork} .card`).style['box-shadow'] = '0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12)';
        //         })
        //     })

        // } else {
        this.setState({ trimPrint },
            () => {
                var divToPrint = document.getElementById('printDevelopmentTrim')
                var newWin = window.open("", "mywindow")
                newWin.document.write(divToPrint.outerHTML)
                newWin.focus()
                newWin.print()
                // this.onPrintFinished(newWin.print())
                newWin.close()
            })

        // }



        // var divToPrint = document.getElementById("trimPrint")
        // // divToPrint.getElementsByClassName('profile-btn')[0].style.display = 'none'
        // html2canvas(divToPrint, {
        //     useCORS: true
        // }).then(canvas => {
        //     console.log(canvas);

        //     const imgData = canvas.toDataURL("image/png")
        //     console.log(imgData);

        //     setTimeout(() => {
        //         var newWin = window.open("", "mywindow")
        //         var img = newWin.document.createElement("img")
        //         img.src = imgData
        //         newWin.document.body.appendChild(img)
        //         newWin.focus()
        //         newWin.print()
        //         newWin.close()
        //         // divToPrint.getElementsByClassName('profile-btn')[0].style.display = 'block'
        //     }, 100);
        // })      




    }

    render() {
        if (
            this.state.isLoading &&
            Object.keys(this.state.trimOptions).length > 0
        ) {
            const { } = this.state
            return (
                <Fragment>
                    <div className="right-section remove-scroll-for-right ">
                        <div className="row nopadding bg-white">
                            <div className="col-md-12 no-padding">
                                {/* MAIN CONTENT START HERE */}
                                <form id="fabricCreation" className="w-100">
                                    <div className="col-md-12 product-form nopadding">
                                        {/* SIDE-CONTENT START */}
                                        <TrimSidebar
                                            moduleName={"trim"}
                                            number={
                                                this.state.trim.trimNumber !== null
                                                    ? `${this.state.trim.trimNumber}`
                                                    : ""
                                            }
                                            qr={this.state.trim.qr}
                                            image={this.state.trim.trimImage}
                                            HSN={this.state.trim.HSN}
                                            handleImageUpload={this.changeImg}
                                            onInputChange={this.getHsnOptions}
                                            getFabricData={this.onChange}
                                            hsnOptions={this.state.hsnOptions}
                                            disabled={
                                                this.props.rights.view
                                                    ? this.props.rights.create || this.props.rights.edit
                                                        ? false
                                                        : true
                                                    : this.state.disabled
                                            }
                                            removeFabricImage={this.removeFabricImage}
                                        />
                                        {/* SIDE-CONTENT END */}

                                        <div className="right-content-section product-form overflow-scroll" id="trimPrint">
                                            {/* page header section  */}
                                            <PageHeader
                                                header={"TRIM DEVELOPMENT"}
                                                history={this.props.history}
                                            />
                                            <Audit _id={this.state._id} />
                                            <span
                                                className="btn-green-icon mr-3 pull-right"
                                                style={{
                                                    cursor: "pointer"
                                                }}
                                                onClick={(e) => this.printTrim()}
                                            >
                                                <img src={printer} />
                                            </span>
                                            <Fragment>
                                                {/* Trim main section */}
                                                {Object.keys(this.state.trimOptions).length > 0 && (
                                                    <TrimMainSection
                                                        trim={this.state.trim}
                                                        trimOptions={this.state.trimOptions}
                                                        onSelect={this.onSelect}
                                                        disabled={
                                                            this.props.rights.view
                                                                ? this.props.rights.create ||
                                                                    this.props.rights.edit
                                                                    ? false
                                                                    : true
                                                                : this.state.disabled
                                                        }
                                                        suppliersOption={this.state.suppliersOption}
                                                    />
                                                )}
                                                {/* *Upload image section */}
                                                <div className="col-md-12 nopadding mt-3 px-5">
                                                    <FileUpload
                                                        Heading="Upload Images"
                                                        moduleName={"trim"}
                                                        getRefImages={this.getRefImages}
                                                        disabled={
                                                            this.props.rights.view
                                                                ? this.props.rights.create ||
                                                                    this.props.rights.edit
                                                                    ? false
                                                                    : true
                                                                : this.state.disabled
                                                        }
                                                        uploadedDocs={
                                                            this.state.trim.refImages.length > 0
                                                                ? this.state.trim.refImages
                                                                : null
                                                        }
                                                        imageTypeOption={
                                                            this.state.trimOptions
                                                                ? this.state.trimOptions.IMAGETYPE
                                                                : []
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-12 text-center profile-btn">
                                                    {this.state.action === 'add' && !this.state.disabled &&
                                                        this.props.rights.trim.trim.web.create ? (
                                                            <button
                                                                type="button"
                                                                className="primary mr-2"
                                                                name="button"
                                                                onClick={e => this.onSubmit(e)}
                                                            >
                                                                Save
                              </button>
                                                        ) : this.state.action === 'edit' && !this.state.disabled &&
                                                            this.props.rights.trim.trim.web.edit ? (<button
                                                                type="button"
                                                                className="primary mr-2"
                                                                name="button"
                                                                onClick={e => this.onSubmit(e)}
                                                            >
                                                                Save
                              </button>
                                                            ) : null}
                                                    <Button
                                                        buttonType="cancel"
                                                        buttonName="cancel"
                                                        history={this.props.history}
                                                    />
                                                </div>

                                                {/** supplier section */}
                                                {this.state.action === 'add' && !this.state.disabled &&
                                                    this.props.rights.trim.supplier.web.create ? (
                                                        <SupplierSection
                                                            action={this.state.action}
                                                            moduleName={"trims"}
                                                            scrollSupplier={false}
                                                            getFullPackage={this.getFullPackage}
                                                            getJobWork={this.getJobwork}
                                                            suppliersOption={this.state.supplierInfo}
                                                            fullPackageData={
                                                                this.state.trim.supplierSection.fullPackageData
                                                            }
                                                            jobWorkData={
                                                                this.state.trim.supplierSection.jobWorkData
                                                            }
                                                            getSupplierForDefault={this.getSupplierForDefault}
                                                            supplierSection={this.state.trim.supplierSection}
                                                            getSupplier={this.getSupplier}
                                                            suppliersOption={this.state.suppliersOption}
                                                            toggle={this.state.toggle}
                                                            // disabled={this.state.disabled}
                                                            fabricInfo={this.state.trimOptions}
                                                            _id={this.state._id}
                                                            disabled={
                                                                this.props.rights.view
                                                                    ? this.props.rights.create ||
                                                                        this.props.rights.edit
                                                                        ? false
                                                                        : true
                                                                    : this.state.disabled
                                                            }
                                                            history={this.props.history}
                                                            unauthorisedFunc={this.props.unauthorisedFunc}
                                                            getalertMessage={this.props.getalertMessage}
                                                        />
                                                    ) : this.state.action === 'edit' && !this.state.disabled &&
                                                        this.props.rights.trim.supplier.web.edit ? (
                                                            <SupplierSection
                                                                action={this.state.action}
                                                                moduleName={"trims"}
                                                                scrollSupplier={false}
                                                                getFullPackage={this.getFullPackage}
                                                                getJobWork={this.getJobwork}
                                                                suppliersOption={this.state.supplierInfo}
                                                                fullPackageData={
                                                                    this.state.trim.supplierSection.fullPackageData
                                                                }
                                                                jobWorkData={
                                                                    this.state.trim.supplierSection.jobWorkData
                                                                }
                                                                getSupplierForDefault={this.getSupplierForDefault}
                                                                supplierSection={this.state.trim.supplierSection}
                                                                getSupplier={this.getSupplier}
                                                                suppliersOption={this.state.suppliersOption}
                                                                toggle={this.state.toggle}
                                                                // disabled={this.state.disabled}
                                                                fabricInfo={this.state.trimOptions}
                                                                _id={this.state._id}
                                                                disabled={
                                                                    this.props.rights.view
                                                                        ? this.props.rights.create ||
                                                                            this.props.rights.edit
                                                                            ? false
                                                                            : true
                                                                        : this.state.disabled
                                                                }
                                                                history={this.props.history}
                                                                unauthorisedFunc={this.props.unauthorisedFunc}
                                                                getalertMessage={this.props.getalertMessage}
                                                            />
                                                        ) : this.props.location.state.action === "view" && this.props.rights.trim.supplier.web.view ?
                                                            (<SupplierSection
                                                                action={this.state.action}
                                                                moduleName={"trims"}
                                                                scrollSupplier={false}
                                                                getFullPackage={this.getFullPackage}
                                                                getJobWork={this.getJobwork}
                                                                suppliersOption={this.state.supplierInfo}
                                                                fullPackageData={
                                                                    this.state.trim.supplierSection.fullPackageData
                                                                }
                                                                jobWorkData={
                                                                    this.state.trim.supplierSection.jobWorkData
                                                                }
                                                                getSupplierForDefault={this.getSupplierForDefault}
                                                                supplierSection={this.state.trim.supplierSection}
                                                                getSupplier={this.getSupplier}
                                                                suppliersOption={this.state.suppliersOption}
                                                                toggle={this.state.toggle}
                                                                // disabled={this.state.disabled}
                                                                fabricInfo={this.state.trimOptions}
                                                                _id={this.state._id}
                                                                disabled={
                                                                    this.props.rights.view
                                                                        ? this.props.rights.create ||
                                                                            this.props.rights.edit
                                                                            ? false
                                                                            : true
                                                                        : this.state.disabled
                                                                }
                                                                history={this.props.history}
                                                                unauthorisedFunc={this.props.unauthorisedFunc}
                                                                getalertMessage={this.props.getalertMessage}
                                                            />
                                                            ) : null}
                                                <div id="printDevelopmentTrim" className="d-none">
                                                    {Object.keys(this.state.trimPrint).length && <PrintDevelopmentTrim
                                                        trim={this.state.trimPrint}
                                                    />}
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return <Loading />
        }
    }
}

const mapStateToProps = state => {
    return {
        rights: state.main.rights
    }
}

export default connect(
    mapStateToProps,
    null
)(Trim)


// WEBPACK FOOTER //
// ./src/pages/Trim/page.js